import { Warning20Filled } from '@fluentui/react-icons';

import { IconLabel } from '@shared/components';

type TProps = {
  userNames: string[];
};

const InvalidApprovalFunctionWarning = ({ userNames }: TProps) => {
  if (!userNames.length) return null;

  return (
    <IconLabel icon={<Warning20Filled />}>
      Some users ({userNames.join(', ')}) have a missing or invalid function. Remove or reassign them here, or update
      their group membership under Settings &gt; User management.
    </IconLabel>
  );
};

export default InvalidApprovalFunctionWarning;
